import {RegulationUSTimeFormatter} from "../regulation-us-time-formatter";

export class MichiganTimeFormatter extends RegulationUSTimeFormatter {
    protected _getTimeZone(): string {
        return 'America/Detroit';
    }
}